import { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { trpc } from '../utils/trpc/trpc.ts';


/**
 * Component that checks if the application has been updated.
 * Prompts the user to refresh the page if the version has changed.
 */
export function AppVersionCheck() {

    const [portalContainer] = useState(document.createElement('div'));
    const [showNotification, setShowNotification] = useState(false);


    const { data: currentVersion } = trpc.serverState.getAppVersion.useQuery(undefined, {
        refetchInterval: 60_000,
    });

    // Check if the version has changed
    useEffect(() => {
        if (!currentVersion) {
            return;
        } else if (currentVersion !== import.meta.env.APP_VERSION) {
            setShowNotification(true);
        }
    }, [currentVersion]);

    // Add portalContainer to DOM
    useEffect(() => {
        if (showNotification) {
            document.body.appendChild(portalContainer);
        }
        return () => {
            if (portalContainer.parentNode) {
                portalContainer.parentNode.removeChild(portalContainer);
            }
        };
    }, [showNotification, portalContainer]);


    if (!showNotification) return null;
    return ReactDOM.createPortal(
        <div className='update-notification' style={{ visibility: 'visible' }}>
            <span>The application has been updated.</span>
            <button onClick={() => window.location.reload()}>Refresh</button>
        </div>,
        portalContainer
    );
}
